import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import { reloadWindowToPath } from "../../Helpers/Utils";
import { useParams } from "react-router-dom";
// 1. Import React Select
import Select from "react-select";

const UpdateVehicle = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const loading = useSelector(s => s.loading.loading);

    const [form, setForm] = useState({
        vehicle_number: "",
        lorry_type: "",
        capacity: "",
        status: "available"
    });

    // 2. Options for React Select
    const statusOptions = [
        { value: "available", label: "Available" },
        { value: "in_use", label: "In Use" },
        { value: "maintenance", label: "Maintenance" }
    ];

    const loadVehicle = async () => {
        dispatch(loadingTrue());
        const res = await Handler({
            method: "get",
            url: `/vehicle/view.php?id=${id}`
        });

        if (res.success) {
            setForm(res.data?.vehicle_info);
        }
        dispatch(loadingFalse());
    };

    useEffect(() => { loadVehicle() }, []);

    const handleChange = e => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    // 3. Special handler for React Select
    const handleSelectChange = (selectedOption, actionMeta) => {
        setForm({ ...form, [actionMeta.name]: selectedOption.value });
    };

    const handleSubmit = async e => {
        e.preventDefault();
        dispatch(loadingTrue());

        const res = await Handler({
            method: "post",
            url: "/vehicle/update.php",
            data: { id, ...form }
        });

        if (res.success) {
            toast.success(res.message);
            setTimeout(() => reloadWindowToPath("/vehicles"), 1000);
        } else {
            toast.error(res.message);
        }
        dispatch(loadingFalse());
    };

    return (
        <div className="page-card">
            <div className="page-header">
                <h4>Edit Vehicle</h4>
            </div>

            <form onSubmit={handleSubmit} className="form-grid">
                <div className="form-group">
                    <label>Vehicle Number</label>
                    <input
                        name="vehicle_number"
                        className="form-control text-uppercase"
                        value={form.vehicle_number || ""}
                        placeholder="Enter vehicle number"
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Lorry Type</label>
                    <input
                        name="lorry_type"
                        className="form-control"
                        value={form.lorry_type || ""}
                        placeholder="Enter lorry type"
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Capacity</label>
                    <input
                        name="capacity"
                        className="form-control"
                        value={form.capacity || ""}
                        placeholder="Enter capacity"
                        onChange={handleChange}
                        required
                    />
                </div>

                {/* 4. React Select Implementation */}
                <div className="form-group">
                    <label>Status</label>
                    <Select
                        name="status"
                        options={statusOptions}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        // Matching the current value from state to the option object
                        value={statusOptions.find(opt => opt.value === form.status)}
                        onChange={handleSelectChange}
                        placeholder="Select Status"
                    />
                </div>

                <div className="form-group full">
                    <button className="btn add-btn-add" disabled={loading}>
                        {loading
                            ? (<><span className="spinner-border spinner-border-sm me-2"></span>Updating...</>)
                            : "Update Vehicle"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default UpdateVehicle;